/* =========================================================
   INDILOOM THEME | collection.js  (AJAX filters + sort for collection and search pages)
   ========================================================= */
(function () {
  'use strict';
  function init(sec) {
    if (sec.ilColl) return;
    sec.ilColl = true;
    var sid = sec.getAttribute('data-section');
    var form = document.getElementById('il-facets-form-' + sid);
    if (!form) return;
    var timer, ctrl;

    function render(href) {
      var u = new URL(href, window.location.origin);
      var results = document.getElementById('il-results-' + sid);
      if (results) results.classList.add('is-loading');
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var q = u.searchParams; q.delete('section_id'); q.delete('page');
      var fetchUrl = u.pathname + '?' + (q.toString() ? q.toString() + '&' : '') + 'section_id=' + sid;
      fetch(fetchUrl, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['il-facets-' + sid, 'il-active-' + sid, 'il-count-' + sid, 'il-results-' + sid].forEach(function (id) {
            var a = document.getElementById(id), b = doc.getElementById(id);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          var clean = u.pathname + (q.toString() ? '?' + q.toString() : '');
          window.history.replaceState({}, '', clean);
          var res = document.getElementById('il-results-' + sid);
          if (res) { res.classList.remove('is-loading'); if (window.ilInit) window.ilInit(res); }
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') window.location.href = u.toString(); });
    }

    var sortSel = sec.querySelector('[data-sort]');
    function fromForm() {
      var p = new URLSearchParams(new FormData(form)), out = new URLSearchParams();
      var def = sortSel ? sortSel.getAttribute('data-default') : '';
      p.forEach(function (v, k) { if (v !== '' && !(k === 'sort_by' && v === def)) out.append(k, v); });
      render((form.getAttribute('action') || window.location.pathname).split('?')[0] + '?' + out.toString());
    }

    form.addEventListener('change', function (e) { if (!e.target.matches('[data-price-input]')) fromForm(); });
    form.addEventListener('input', function (e) {
      if (!e.target.matches('[data-price-input]')) return;
      clearTimeout(timer); timer = setTimeout(fromForm, 700);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); fromForm(); });
    if (sortSel) sortSel.addEventListener('change', fromForm);
    sec.addEventListener('click', function (e) {
      var a = e.target.closest('[data-facet-link]');
      if (!a) return;
      e.preventDefault();
      render(a.href);
    });
  }
  /* Collection description after the grid: clamp long text behind Read more */
  function clamp(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-clamp]'), function (b) {
      var btn = b.parentNode.querySelector('[data-clamp-btn]');
      if (!btn || b.ilClamp) return; b.ilClamp = true;
      if (b.scrollHeight <= b.clientHeight + 8) { b.classList.add('is-open'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = b.classList.toggle('is-open');
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-coll]'), init); clamp(scope); }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
